// extracted by mini-css-extract-plugin
export default {"wrap":"yH-z","articleImagesWrap":"zH-z","articleImage":"AH-z","singleImage":"BH-z"};